import React from "react";
import {
  Announcement,
  Navbar,
  Hero,
  Beauty,
  Foundation,
  Contour,
  Concealer,
  Review,
  Banner,
  Feed,
  Art,
  Contact,
  Footer,
} from "./../../components";
const Home = () => {
  return (
    <div>
      <Announcement />
      <Navbar />
      <Hero />
      <Beauty />
      <Foundation />
      <Contour />
      <Concealer />
      <Review />
      <Banner />
      <Feed />
      <Art />
      <Contact />
      <Footer />
    </div>
  );
};

export default Home;
